import { LoaderIcon } from '@/assets/icons'

const Loader = () => {
  return (
    <div className='max-w-[70px] mx-auto block py-[30px]'>
      <LoaderIcon />
    </div>
  )
}

export default Loader
